"use client"

import { Navigate, useLocation } from "react-router-dom"
import { useAuth } from "../context/AuthContext"

function PrivateRoute({ children }) {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  // Check if user is blocked on session-conflict
  const isBlocked = localStorage.getItem("session_conflict_blocked") === "true"

  // If user is blocked and trying to access any route other than session-conflict, redirect back
  if (isBlocked && location.pathname !== "/session-conflict") {
    return <Navigate to="/session-conflict" replace />
  }

  // Show loading while checking authentication
  if (isLoading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner">Loading...</div>
      </div>
    )
  }

  // If user is not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  // If authenticated, show the private route
  return children
}

export default PrivateRoute
